/* import __COLOCATED_TEMPLATE__ from './placeholder-status-label.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */

import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {};
}

const PlaceholderStatusLabel = templateOnlyComponent<Signature>();

export default PlaceholderStatusLabel;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinAiAgent::Knowledge::PlaceholderStatusLabel': typeof PlaceholderStatusLabel;
    'fin-ai-agent/knowledge/placeholder-status-label': typeof PlaceholderStatusLabel;
  }
}
